import { ConfigType } from '@provider-portal/common/config';
import { Store } from 'redux';

import { selectAccessToken } from '@bolteu/redux-session';

import { GlobalAppState } from 'rdx/state';
import { getDeviceInfo, getDeviceUniqueId } from 'utils/deviceInfo';

import { getAppLocale } from '../utils/translations';

export const createGatewaySelectors = ({
  store,
  config,
}: {
  store: Store<GlobalAppState>;
  config: ConfigType;
}) => {
  return {
    getAccessToken: () => {
      const reduxState = store.getState();
      const token = reduxState ? selectAccessToken(reduxState) : null;
      return token || '';
    },
    getShardingKey: () => 'deliveryglobal',
    getDefaultQueryParams: () => {
      return {
        session_id: getDeviceUniqueId(),
        device_id: getDeviceUniqueId(),
        device_name: getDeviceInfo().browser.name || 'unknown',
        device_os_version: getDeviceInfo().os.version?.toString() || 'unknown',
        language: getAppLocale(),
        version: config.version,
      };
    },
  };
};
